import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';

export function useSwitchPricingPlan({
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, string> = {}) {
  const { client } = useAPI();
  const queryClient = useQueryClient();

  const { data: organization } = useCurrentOrganization();

  return useMutation(
    async (planId: string) => {
      if (!organization) {
        return Promise.reject(new Error('No organization provided.'));
      }

      const { data } = await client.put<void>(
        `/internal/orgs/${organization.id}/plan`,
        { id: planId }
      );
      return data;
    },
    {
      ...options,
      onSettled(...args) {
        onSettled?.(...args);
        queryClient.invalidateQueries(['pricing-plan']);
        queryClient.invalidateQueries(['pricing-plans']);
        queryClient.invalidateQueries(['included-nodes']);
      },
    }
  );
}
